import PropTypes from 'prop-types';

export const SiteBuilderSuccessProps = {
  locales: PropTypes.object.isRequired,
  isMobile: PropTypes.bool,
  handleRequestBuilderSso: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};
